<template>
  <div class="infinite-list-wrapper" style="overflow:auto">
    <div class="status-bar flex item-center flex-between">
      <span class="text bold">{{ statusText }}</span>
      <div class="flex item-center">
        <span class="hmicon icon-kaoheliebiaoshuliang"></span>
        <span class="total">{{ total }}</span>
      </div>
    </div>
    <el-scrollbar
      :wrap-style="[{ height: scrollHeight - 120 + 'px' }]"
      ref="scrollContainer"
      :vertical="false"
    >
      <ul
        class="list"
        v-infinite-scroll="queryList"
        infinite-scroll-disabled="disabled"
      >
        <li
          @click="toMgt(v)"
          v-for="(v, i) in list"
          :key="i"
          class="list-item pointer"
          :style="{ borderColor: color }"
        >
          <div class="headline">
            <span :style="{ color }" class="hmicon icon-liebiaoming"></span>
            <span>{{ v.taskName }}</span>
          </div>
          <div class="cycle">
            考核周期：<template v-if="v.loopType === 'year'">年</template
            ><template v-if="v.loopType === 'month'">月</template
            ><template v-if="v.loopType === 'date'">日</template>
          </div>
          <div class="time">
            考核时间：{{ v.loopStartValue }}至{{ v.loopEndValue }}
          </div>
        </li>
      </ul>
      <p class="tips text-center" v-if="loading && !noMore">加载中...</p>
      <p class="tips text-center" v-if="noMore">没有更多了</p>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  props: {
    searchConditions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    confirmStatus: {
      type: String,
      default: ""
    },
    scrollHeight: {
      type: [String, Number],
      default: "500"
    },
    statusText: {
      type: String,
      default: "进行中"
    },
    action: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      count: 10,
      loading: false,
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: {
    noMore() {
      return this.list.length >= this.total;
    },
    disabled() {
      return this.loading || this.noMore;
    }
  },
  created() {
    this.queryList();
  },
  methods: {
    search() {
      this.list = [];
      this.currentPage = 1;
      this.queryList();
    },
    toMgt(row) {
      this.$router.push({
        name: "TaskScore",
        query: {
          taskId: row.id,
          taskName: row.taskName,
          confirmStatus: this.confirmStatus
        }
      });
    },
    async queryList() {
      this.loading = true;
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        confirmStatus: this.confirmStatus
      };
      Object.assign(params, this.searchConditions);
      const { result } = await this.$store.dispatch(this.action, params);
      this.currentPage++;
      const { records, total } = result;
      this.list = this.list.concat(records);
      this.total = total;
      this.loading = false;
    }
  }
};
</script>

<style scoped lang="scss">
.infinite-list-wrapper {
  width: 380px;
  background: #f7f7f7;
  margin-right: 10px;
  flex-shrink: 0;
  box-shadow: 0px 0px 20px 0px rgba(221, 221, 221, 0.7);
}
.status-bar {
  padding: 16px;
  .text {
    font-size: 16px;
  }
  .hmicon {
    font-size: 20px;
    color: #666;
  }
  .total {
    margin-left: 8px;
    color: #666;
  }
}
.list {
  .list-item {
    background: #fff;
    border-radius: 4px;
    border-left: 4px solid;
    margin: 0 10px 10px;
    padding: 18px 20px;
  }

  .headline {
    margin-bottom: 20px;
    line-height: 30px;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
    .hmicon {
      margin-right: 8px;
      font-size: 20px;
    }
  }

  .cycle {
    font-size: 14px;
    color: #666;
    margin-bottom: 16px;
  }

  .time {
    font-size: 14px;
    color: #666;
  }
}
.tips {
  margin: 20px 0;
}
</style>
